import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const searchCourses = createApiThunk<Course[], ClubAndCourseSearchPayload>({
  action: 'courses/search',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_SEARCH_COURSES,
  getData: (payload) => payload.data,
})

export const searchCoursesByCourseOrClubName = createApiThunk<CourseSearchResponse, CourseSearchPayload>({
  action: 'courses/searchByCourseOrClubName',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_COURSES_BY_COURSE_OR_CLUB_NAME,
  getParams: (payload) => payload,
})

export const getCoursesById = createApiThunk<CourseSearchByIdsResponse, CoursesSearchWithIdPayload>({
  action: 'courses/searchWithIds',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_COURSES_BY_IDS,
  getParams: (payload) => payload,
})
